import { getSelectOptions } from '@/exceed';

const getAudiences = (audiences) => (
  getSelectOptions([
    { audience_type: 'Customer', id: 1, name: 'Audience One' },
    { audience_type: 'Employee', id: 2, name: 'Audience Two' },
    { audience_type: 'Partner', id: 3, name: 'Audience Three' },
  ], { selection: audiences })
);

const getDashboards = () => [
  { extra_filters: ['type_of_training'], id: 1, type: 'acquisition' },
  { id: 2, type: 'engagement' },
];

const getIframeUrl = () => 'https://data-viz.intellum.com/embed/dashboard/eyJhbGciOiJIUzI1NiJ9.eyJyZXNvdXJjZSI6eyJkYXNoYm9hcmQiOjc3fSwicGFyYW1zIjp7ImNsdXN0ZXJfbmFtZSI6IlByaW1hcnkiLCJjbHVzdGVyX2lkIjowLCJhY2NvdW50X2lkIjoxMDI2LCJncm91cF9pZHMiOiI2Njc0Niw1ODE1OCIsInR5cGVfb2ZfdHJhaW5pbmciOiJib3RoIiwidGFnX2lkcyI6Ijk5ODcsOTk4NiIsInRvcGljX2lkcyI6IjI0MzEwIn0sImV4cCI6MTY1NTY1NTM1M30.lsA-QxbVPReCjtFk--ouAdGCHvHs6pG7AIzvXe0tvag#bordered=false&titled=false';

const getInitiatives = () => [
  {
    audiences: [
      { audience_type: 'Customer', id: 1, name: 'Audience One' },
      { audience_type: 'Partner', id: 3, name: 'Audience Three' },
    ],
    content_count: 976,
    id: 1,
    initiative_type: 'Enablement',
    name: 'Intellum Platform Learning',
  },
  {
    audiences: [{ audience_type: 'Employee', id: 2, name: 'Audience Two' }],
    content_count: 13,
    id: 2,
    initiative_type: 'Onboarding',
    name: 'On the Level: New Hire Orientation and Onboarding',
  },
];

const getInitiative = (id) => {
  const initiatives = getInitiatives();

  return initiatives.find((initiative) => (initiative.id === id)) || initiatives[0];
};

const getSparkline = () => 'https://chart.apis.google.com/chart?chco=3168F6&chf=bg,s,00000000&chd=s:fffff&cht=ls&chs=200x100&chxr=0,0,20%7C1,0,20';

const getTopics = () => [
  {
    id: 1,
    is_section: true,
    name: 'Course Offerings',
    topics: [{ id: 4, name: 'Data & Insights' }, { id: 7, name: 'Sub Topic 1' }],
  },
  {
    id: 2,
    is_section: true,
    name: 'Help Articles',
    topics: [{ id: 5, name: 'Sub Topic 2' }],
  },
  {
    id: 3,
    is_section: true,
    name: 'Support & Feedback',
    topics: [{ id: 6, name: 'Sub Topic 3' }, { id: 8, name: 'Sub Topic 4' }],
  },
];

const getTaggableContent = async (input) => (
  getSelectOptions(getTopics().filter(({ name }) => name.toLowerCase().includes(input)))
);

const getTopicSelection = () => [
  {
    id: 3,
    is_section: true,
    name: 'Support & Feedback',
  },
  {
    id: 2,
    is_section: true,
    name: 'Help Articles',
  },
  {
    id: 4,
    is_section: false,
    name: 'Data & Insights',
  },
];

export {
  getAudiences,
  getDashboards,
  getIframeUrl,
  getInitiative,
  getInitiatives,
  getSparkline,
  getTaggableContent,
  getTopics,
  getTopics as getInitiativeUsage,
  getTopicSelection,
};
